import * as colors from '../colors';

export default {
  root: {
    '&.Mui-focused:not(.Mui-error)': {
      color: colors.grey[600],
    },
  },
  shrink: {
    transform: 'translate(0, 1.5px) scale(0.875)',
  },
};
